import React, { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { CustomDropdown } from '../common/index.js';

export const chartFileSlug = (value) => {
  const slug = String(value || 'chart')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
  return slug || 'chart';
};

export const AGGREGATION_MODE_OPTIONS = [
  { value: 'cumulative', display: 'Cumulative' },
  { value: 'individual', display: 'Individual' },
];

export const useAggregationMode = () => {
  const [mode, setMode] = useState('cumulative');
  const [overTimeOpen, setOverTimeOpen] = useState(false);
  const [activityOpen, setActivityOpen] = useState(false);
  const [filterBarOpen, setFilterBarOpen] = useState(false);

  const close = useCallback(() => {
    setOverTimeOpen(false);
    setActivityOpen(false);
    setFilterBarOpen(false);
  }, []);

  const toggleOverTime = useCallback(() => {
    setOverTimeOpen(open => !open);
    setActivityOpen(false);
    setFilterBarOpen(false);
  }, []);

  const toggleActivity = useCallback(() => {
    setActivityOpen(open => !open);
    setOverTimeOpen(false);
    setFilterBarOpen(false);
  }, []);

  const toggleFilterBar = useCallback(() => {
    setFilterBarOpen(open => !open);
    setOverTimeOpen(false);
    setActivityOpen(false);
  }, []);

  const select = useCallback((option) => {
    if (option?.value === 'individual' || option?.value === 'cumulative') {
      setMode(option.value);
    }
    setOverTimeOpen(false);
    setActivityOpen(false);
    setFilterBarOpen(false);
  }, []);

  return {
    mode,
    overTimeOpen,
    activityOpen,
    filterBarOpen,
    toggleOverTime,
    toggleActivity,
    toggleFilterBar,
    close,
    select,
  };
};

export const AggregationModeDropdown = ({ mode, isOpen, onToggle, onSelect }) => (
  <CustomDropdown
    className="chart-mode-dropdown"
    width="150px"
    options={AGGREGATION_MODE_OPTIONS}
    selectedOption={mode === 'individual' ? 'Individual' : 'Cumulative'}
    onSelect={onSelect}
    isOpen={isOpen}
    toggleDropdown={onToggle}
    keyExtractor={(option) => `aggregation-mode-${option.value}`}
  />
);

export const ChartDownloadButton = ({ onClick, disabled, title = 'Download chart data' }) => (
  <button
    type="button"
    className="insights-download-button insights-download-button-icon"
    onClick={onClick}
    disabled={disabled}
    title={title}
    aria-label={title}
  >
    <FontAwesomeIcon icon={faDownload} />
  </button>
);

export const ChartHeader = ({ title, children }) => (
  <div className="chart-header">
    <h2>{title}</h2>
    {children ? <div className="chart-header-actions">{children}</div> : null}
  </div>
);
